import React, { useState, useEffect } from "react";
import {
  Container,
  Form,
  Button,
  Card,
  Row,
  Col,
  Alert,
  ListGroup,
} from "react-bootstrap";
import Layout from "../layout/DefaultLayout";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { useQuery, useMutation, useQueryClient } from "react-query";
import api from "../utils/helper"; // Adjust this import to your API helper
import { useAlerts } from "../context/AlertContext";

const Setting = () => {
  const queryClient = useQueryClient();
  const { showSuccess, showError } = useAlerts();
  // const [toEmail, setToEmail] = useState("");
  const [fromEmail, setFromEmail] = useState("");
  const [error, setError] = useState("");

  const { data: emailSettings, isLoading } = useQuery(["email-settings"], () =>
    api.get("/setting/get").then((res) => res.data)
  );

  useEffect(() => {
    if (emailSettings) {
      // setToEmail(emailSettings.emailTo || "");
      setFromEmail(emailSettings.emailFrom || "");
    }
  }, [emailSettings]);

  // 🔹 Handle PUT (update settings)
  const updateSettingsMutation = useMutation(
    (formData) => api.put("/setting/set", formData),
    {
      onSuccess: (res) => {
        showSuccess(res.data?.message || "Settings updated successfully!");
        queryClient.invalidateQueries(["email-settings"]);
      },
      onError: (err) => {
        showError(err?.response?.data?.message || "Failed to update settings");
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const newEmail = `${fromEmail}@hytechlms.com`;
    updateSettingsMutation.mutate({ emailFrom: newEmail });
    // console.log("To Email:", toEmail);
    console.log("From Email:", fromEmail);
  };

  const handleUsernameChange = (e) => {
    const input = e.target.value;

    if (!/^[a-zA-Z0-9.]*$/.test(input)) {
      setError("Only letters, numbers, and . are allowed.");
    } else if (input.includes("@") || input.includes(".com")) {
      setError("Do not include '@' or '.com' in the username.");
    } else {
      setError("");
      setFromEmail(input);
    }
  };

  return (
    <Layout>
      <div className="bgNav d-block d-lg-none pb-5 px-1 position-relative">
        <h1 className="heading text-white px-3">Setting</h1>
      </div>
      <Container
        fluid
        className="main-container main-subcontainer mt-0 mt-md-4 ps-auto ps-md-0"
      >
        <Card className="form-card">
          <Card.Header className="heading d-none d-lg-block">
            Email Settings
          </Card.Header>
          <Card.Body>
            <div>
              <Form className="d-flex" onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="fromEmail">
                  {/* <Form.Label>From Email (Action Email)</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter sender email"
                    value={fromEmail}
                    onChange={(e) => setFromEmail(e.target.value)}
                    required
                  /> */}

                  <Form.Label>
                    Username{" "}
                    <span
                      title="Enter the part before @hytechlms.com"
                      style={{ cursor: "pointer", color: "#0d6efd" }}
                    >
                      &#9432;
                    </span>
                  </Form.Label>
                  <div className="d-flex align-items-center border rounded px-2">
                    <Form.Control
                      type="text"
                      placeholder="Enter your username here."
                      value={fromEmail}
                      onChange={handleUsernameChange}
                      required="Email is required"
                      style={{ border: "none" }}
                    />
                    <span className="text-muted">@hytechlms.com</span>
                  </div>
                  {error && <div className="text-danger mt-1">{error}</div>}
                </Form.Group>

                <div style={{ marginTop: "30px" }}>
                  <Button
                    color="#60B1FF"
                    className="ms-2 "
                    disabled={updateSettingsMutation.isLoading}
                    type="submit"
                  >
                    {updateSettingsMutation.isLoading ? "Saving..." : "Save"}
                  </Button>
                </div>
              </Form>
            </div>
          </Card.Body>
        </Card>
      </Container>
      <div className="d-none d-lg-block">
        <Footer />
      </div>
    </Layout>
  );
};

export default Setting;
